<template>
    <div class="">
        <div class="custom-loader-wrapper" v-if="loader">
            <div class="text-center">
                <span class="d-block max-450">We are processing your download and this may take some time. Do not close this window until the download begins.</span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                <p class="mt-5">Plesae click <a target="_blank" :href="$api_url+'/company/dashboard'">here</a> or below if you want to continue surfing the system.</p>
                <b-button  class="mb-1"  target="_blank"  :href="$api_url+'/company/dashboard'">Dashboard</b-button>

            </div>
        </div>
        {{checkYears}}
        <div class="row mt-4 no-margin">
            <div class="ibox col-md-12">
                <div class="ibox-title dashboard_title px-0">
                    <h4 class="font-regular with-blue-text">Current Selected: <span>Profit Payable</span></h4>
                </div>
                <div class="ibox-content px-0 trz_ppl_wrapper_2 mt-3">
                    <div class="d-inline-block form-group">
                        <label>From</label>
                        <b-form-select v-model="start_year">
                            <b-form-select-option value="">Select Fiscal Year</b-form-select-option>
                            <b-form-select-option v-for="(year, n) in from_years" :key="n" :value="year">{{toFiscalString(year)}}</b-form-select-option>
                        </b-form-select>
                    </div>
                    <div class="d-inline-block ml-2 form-group">
                        <label>To</label>
                        <b-form-select v-model="to_year">
                            <b-form-select-option value="">Select Fiscal Year</b-form-select-option>
                            <b-form-select-option v-for="(year, n) in to_years" :key="n" :value="year">{{toFiscalString(year)}}</b-form-select-option>
                        </b-form-select>
                    </div>
                    <div class="d-inline-block float-right ml-2">
                        <!-- <button v-on:click="viewDetails()" :disabled="disableme" class="btn btn-primary position-static mr-3">Preview Report</button> -->
                        <button v-on:click="getReport()" :disabled="disableme" class="btn btn-primary position-static">Download</button>
                    </div>
                </div>
            </div>
        </div>


        <b-modal id="bv-modal-PPR" size="sm" hide-footer title="Profit Payable Report">
            <div>No data available for that date range!</div>
        </b-modal>

        <b-modal id="profit-payable-report" dialog-class="modal-xxl" size="xl" scrollable  hide-footer title="Profit Payable Report">
            <b-overlay  rounded="sm">
                <div class="clearfix row py-2 mb-2 border-bottom">

                    <div class="col-md-6">
                        <b-input-group class="mb-0 custom-search ml-auto mr-0">
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                        </b-input-group>
                    </div>
                </div>

                <table class="table ">
                    <thead class="" style="">
                        <tr class="table-head"  v-for="(detail, index) in paginatedData" :key="detail.employee_code">
                            <template v-if="index < 1">
                                <td class="text-center" v-for="(v,i,count) in detail"><template>{{ replaceTableHeads(i) }}</template></td>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="display: none;"></tr>
                        <tr class="table-row hover-bg " v-for="detail in paginatedData" :key="detail.employee_code">
                            <!--aboni 10-11-21-->
                            <template v-for="(v,i,count) in detail">
                                <td class="2" v-if="i == 'Employee Name' || i== 'Employee Code' || i== 'Designation'">{{v}} </td>
                                <td v-else   class="2 text-right" ><div v-if="v==0">--</div><div v-else>{{formatMoney(v)}}</div></td>

                            </template>
                            <!--aboni 10-11-21-->


                        </tr>
                    </tbody>
                </table>
                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">
                    <span class="d-block text-center">{{empty_result}}</span>
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div v-else class="px-3"><b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav></div>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>


    export default{

        mounted() {
            this.$refs.trzcalendar;
        },
        props: ['pageurl' , 'flag','leaver'],
        components: {

        },
        data(){

            return {

                pageUrl:this.$api_url,
                table_heads :[],
                search:'',
                length: 20,
                pagination: {currentPage: 1, pages:1},
                from_years:[],
                to_years:[],
                empty_result : 'Please hold tight! We are preparing the report data for you!',
                disableme :false,
                start_year : '',
                to_year:'',
                currentYear: new Date().getFullYear(),
                currentMonth:new Date().getMonth(),
                start_month: '',
                start_month_name: '',
                loader: false,
                showoverlay : true,

                payroll_reporting_data : [],
                details : [],

                months: [
                    { value: "1", text: "January" },
                    { value: "2", text: "February" },
                    { value: "3", text: "March" },
                    { value: "4", text: "April" },
                    { value: "5", text: "May" },
                    { value: "6", text: "June" },
                    { value: "7", text: "July" },
                    { value: "8", text: "August" },
                    { value: "9", text: "September" },
                    { value: "10", text: "October" },
                    { value: "11", text: "November" },
                    { value: "12", text: "December" },
                ],
                /***Ali */
                report_data:[],
                column_selected:[],
                column_options:[],
                default_fields:[],
                column_selected_view:[],
                show_selected:'',


            }
        },
        methods:{

            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            toFiscalString(year)
            {
                year = parseInt(year);

                var year_2 = year+1;

                var year_str = year +'-'+year_2;

                return year_str;
            },
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }

            //     return money;
            // },
            getPayrollReporting: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/report/payrollreporting' , {
                    params: {

                    }
                }).then(function(response){
                    this.payroll_reporting_data = response.data;
                    //console.log(this.payroll_reporting_data);

                }.bind(this));
            },
            getYears()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/pf/get-tax-rules-years' , {
                }).then(function(response){

                    this.from_years = response.data;
                    this.to_years = response.data;


                    this.start_year =this.from_years[0];
                    this.to_year=this.from_years[this.from_years.length-1];
                }.bind(this));
            },
            getReport: function()
            {
                if(!this.checkNet()) return false;
                this.loader = true;
                let url = ''

                url = this.$api_url + '/pf/report/profit-payable';

                let formData = new FormData();
                formData.append('start_year', this.start_year);
                formData.append('end_year', this.to_year);
                formData.append('grid_report', 'Excel');
                formData.append('report', 1);
                let currentObj = this;
                // axios.post(url, formData).then(function (response)
                // {
                //     if(response.data.errors)
                //     {
                //         this.$bvModal.show('bv-modal-YPR');
                //     }
                //     else
                //     {
                //         var fileURL = response.data;
                //         this.download_file(fileURL);
                //     }

                //     this.loader = false;

                // }.bind(this))
                // .catch(error => {
                //     if(error.response){
                //         this.$bvModal.show('bv-modal-YPR');
                //         this.loader = false;
                //     }
                // });
                this.downloadBlobResponse(
                    axios.post(url, formData, { responseType: 'blob' }),
                    'loader',
                    () => {
                        this.$bvModal.show('bv-modal-YPR');
                    }
                );
                return false;
            },
            download_file(fileURL)
            {
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            replaceTableHeads(val){
                val = val.replace(/_/g, ' ');

                val = val.toLowerCase().split(' ');
                for(var i = 0; i < val.length; i++){
                    val[i] = val[i].charAt(0).toUpperCase() + val[i].substring(1);
                }
                return val.join(' ');
            },
            viewDetails: function()
            {
                if(!this.checkNet()) return false;
                this.details = [];
                var months = ["", "January", "February", "March", "April", "May", "June",
           "July", "August", "September", "October", "November", "December" ];


                let formData = new FormData();
                formData.append('start_year', this.start_year);
                formData.append('end_year', this.to_year);
                formData.append('viewmode', 1);
                formData.append('grid_report', 'Excel');
                formData.append('report', 1);
                let url = this.$api_url + '/pf/report/profit-payable';

                let currentObj = this;
                axios.post(url, formData).then(function (response)
                {
                    var list_data = response.data;
                    this.details = list_data;
                    this.loader = false;

                }.bind(this))
                .catch(error => {
                    if(error.response){
                        this.$bvModal.show('bv-modal-PPR');
                        this.loader = false;
                    }
                });



                this.$bvModal.show('profit-payable-report');


            },
            stringView(str) {
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
            capitalizeTheFirstLetterOfEachWord(words) {
            var separateWord = words.toLowerCase().split(' ');
            for (var i = 0; i < separateWord.length; i++) {
                separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
                separateWord[i].substring(1);
            }
            return separateWord.join(' ');
            }

        },
        created: function(){
            this.start_year = this.currentYear;
            this.to_year = this.currentYear;
            this.start_month = this.currentMonth + 1;
            this.getPayrollReporting();
            this.getYears();
        },
        computed:
        {
            checkYears()
            {
                if(this.start_year >  this.to_year)
                {
                    this.disableme = true;
                }
                else
                {
                    this.disableme = false;
                }
            },
            filteredData()
            {
                let filtered_list = this.details;

                console.log(filtered_list);
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }
                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },

        }
    }
</script>

<style>

.d-inline-block.trz_fields.trz-custom-dropdown.mb-1 button {
	position: relative !important;
	bottom: 0 !important;
}
/*
.trz_pr_y
{

}
*/

</style>
